
export default {
  name: "baseReportMixin",
  components: {

  },
  data () {
    return {

    };
  },
  computed: {
  },
  created () {
  },
  mounted () {

  },
  methods: {
    getToolBox (that) {
      return {
        show: true,
        iconStyle: {
          borderColor: "#FFF", // 图标默认颜色
        },
        emphasis: {
          iconStyle: {
            borderColor: "#FFF",// 图标hover颜色
          },
        },
        // itemSize: 20, // 设置图标大小
        feature: {
          /**自定义的工具栏 */
          myTool1: {
            show: this.isShowCloseBtn,
            // title: '关闭', // 图标hover 显示文字
            icon: 'path://M558.933333 529.066667l285.866667 285.866666-29.866667 29.866667-285.866666-285.866667-285.866667 285.866667-29.866667-29.866667 285.866667-285.866666L213.333333 243.2l29.866667-29.866667 285.866667 285.866667L814.933333 213.333333l29.866667 29.866667-285.866667 285.866667z',
            // icon: 'image://关闭_o.png',
            onclick: function () {
              that.myChart.dispose();
              let parent = that.$refs['myChart'].parentNode;
              console.log(parent.parentNode.id, "parent.parentNode.id")
              that.$emit('StateChange', 0, parent.parentNode.id);
              console.log(parent, "parent", that);
              parent.parentNode.classList.add('hide');
            }
          }
        }
      }
    },

    getPercentage (num1, num2) {
      if (!num2) return 100
      if (!num1) return 0
      let num = Math.floor((num1 / num2 * 100) * 100) / 100
      if (num > 100) num = 100
      return num
    },

  },
};
